import defaultFlows from './defaultFlows'
import defaultFlowCustomPage from './defaultFlowCustomPage'
import mobileVet from './mobileVet'
import registration from './registration'
import walkIn from './walkIn'
import allUserValidCard from './allUserValidCard'
import newUserValidCard from './newUserValidCard'
import allUserChargeCard from './allUserChargeCard'
import newUserChargeCard from './newUserChargeCard'
import defaultWaitList from './defaultWaitList'

export default {
    defaultFlows,
    defaultFlowCustomPage,
    mobileVet,
    registration,
    walkIn,
    allUserValidCard,
    newUserValidCard,
    allUserChargeCard,
    newUserChargeCard,
    defaultWaitList
}


// WEBPACK FOOTER //
// ./eventFlows/index.js